









































import { Component, Vue } from 'vue-property-decorator';
import VideoPlayer from '@/components/VideoPlayer.vue';
import GameLogic from "../services/GameLogic";
import PanningViewport from "../components/PanningViewport.vue";
import VideoCaptions from "./VideoCaptions.vue";
import LocaleText from "@/components/LocaleText.vue";
import HotspotBubble from "./components/HotspotBubble.vue";
import Animations from "../services/Animations";

@Component({
    data: function () {
        return {
            showOverlay: false,
            videoSkipped: false,
        }
    },
    computed: {
        getVideoUrl(): string {
            return this.$store.getters.currentIntroVideo;
        },
        getVpkPosition():any {
            let pos = GameLogic.getSituationStartPosition(this.$store.state, 'roomViewToggleButtonPosition');
            return GameLogic.getPositionStyle(pos, 1920, 960);
        }
    },
    components: {
        VideoCaptions,
        PanningViewport,
        VideoPlayer,
        LocaleText,
        HotspotBubble
    },
    created() {
        this.$store.commit('startDay');
        //this.$store.commit('showTip', 'algemeen.tutorial.tip1.text');
    },
    methods: {
        handleVideoEnded(): void {

            // TODO destroy VideoCaptions or send 'quit' message

            // console.log('DayVideo: video ended');

            this.$data.videoSkipped = true;
            this.$data.showOverlay = true;

            (<HTMLAudioElement>this.$refs.postVideoAudio).play();
        },
        handleSwitch():void {
            this.$store.commit('hideTip', 'algemeen.tutorial.tip1.text');

            // TODO: animation timeline framework (bijv Velocity, geen Greensock)
            Animations.fadeIn(this.$refs.fader, 1)
                //.then(() => Animations.wait(1))
                .then(() => Animations.fadeIn(this.$refs.switchAnim, .25))
                .then(() => Animations.wait(1))
                .then(() => { (<HTMLAudioElement>this.$refs.switchAudio).play(); })
                .then(() => {
                    Animations.animate(this.$refs.eyelid, 'switch-blink', .5 );
                    return Animations.animate(this.$refs.labels, 'switch-slideUp', .25 );
                })
                .then(() => Animations.wait(1))
                .then(() => Animations.fadeOut(this.$refs.switchAnim, .25))
                .then(() => this.$router.push('/day/' + this.$store.state.day + '/nurse'));
        }
    }
})
export default class DayVideo extends Vue {
    showOverlay: boolean = false;
}
